import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { Link as RouterLink } from 'react-router-dom';
import { Button } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import AddIcon from '@mui/icons-material/Add';
import Search from 'src/components/View/Header/Search';
import SelectStatus from 'src/components/View/Header/SelectStatus';
import ButtonInner from 'src/components/View/Header/ButtonInner';
import FilterForm from 'src/views/management/ScheduledMessagesView/FilterForm';
import { ROUTES } from 'src/constants';
import {
  setVisibleModalFormNumber,
} from 'src/actions/customersActions';

import searchBoxStyle from 'src/views/management/ScheduledMessagesView/searchBox.style';
import { useDispatch } from 'react-redux';

const useStyles = makeStyles()(searchBoxStyle);

function SearchBox({
  query,
  setSearch,
  onSearch,
  setCopyValuesToBack,
  loading,
  onChangeStatus,
  canFilterByBirthdayMessage = false,
  canFilterByHostInvite = false,
}) {
  const { classes } = useStyles();
  const dispatch = useDispatch();
  const {
    status,
    search,
    filters,
  } = query || {};

  const statusOptions = [
    {
      title: 'Scheduled',
      value: 'scheduled',
      active: status === 'scheduled',
    },
    {
      title: 'Sent',
      value: 'sent',
      active: status === 'sent',
    },
  ];

  const handleOnChangeStatus = (val) => {
    const { value } = val || {};
    if (value) {
      onChangeStatus(value);
    }
  };

  const handleClearSearch = () => {
    setSearch('');
    onSearch();
  };

  const handleClickCreateNew = useCallback(() => {
    setCopyValuesToBack();
    dispatch(setVisibleModalFormNumber(5));
  }, [setCopyValuesToBack]);

  return (
    <>
      <SelectStatus
        options={statusOptions}
        onChange={handleOnChangeStatus}
      />
      <Search
        search={search}
        setSearch={setSearch}
        onSearch={onSearch}
        onClear={handleClearSearch}
      />
      <FilterForm
        filterValues={filters}
        status={status}
        canFilterByBirthdayMessage={canFilterByBirthdayMessage}
        canFilterByHostInvite={canFilterByHostInvite}
      />
      <ButtonInner>
        <Button
          className={classes.buttonAdd}
          variant="contained"
          component={RouterLink}
          to={ROUTES.APP_MANAGEMENT_CUSTOMERS}
          onClick={handleClickCreateNew}
          disabled={!!loading}
        >
          <AddIcon />
          Create New
        </Button>
      </ButtonInner>
    </>
  );
}

SearchBox.propTypes = {
  query: PropTypes.object.isRequired,
  setSearch: PropTypes.func.isRequired,
  onSearch: PropTypes.func.isRequired,
  setCopyValuesToBack: PropTypes.func.isRequired,
  onChangeStatus: PropTypes.func.isRequired,
  loading: PropTypes.bool,
  canFilterByBirthdayMessage: PropTypes.bool,
  canFilterByHostInvite: PropTypes.bool,
};

export default SearchBox;
